import React, { Component } from 'react';
import Formula from './Formula.js';




class Manifest extends Component {
    
    constructor(props) 
    {
        super(props)

        this.state = {
            application: props.application,
            updateApp: props.updateApp,
            cache: props.application.engine.cache(),
            network: props.application.engine.network(),
            manifest: props.manifest,
            init_manifest: props.manifest,
            rootManifest: props.rootManifest,
            showData: props.showData,
            dataTogglePopup: props.dataTogglePopup,
            showFormulas: props.showFormulas,
            

        }

        this.handleFetchManifest = this.handleFetchManifest.bind(this)
        this.handleRemoveManifest = this.handleRemoveManifest.bind(this)
        
        this.handleFetchData = this.handleFetchData.bind(this)
        this.handleRemoveData = this.handleRemoveData.bind(this)
        this.handleViewData = this.handleViewData.bind(this)
        this.handleManifestView = this.handleManifestView.bind(this)
        

        if (this.state.rootManifest)
        {
            this.updateManifest = this.updateManifest.bind(this)
            this.state.application.setUpdateManifest(this.updateManifest)
        }

        this.handleChangeManifestFocus = this.handleChangeManifestFocus.bind(this)
    }

    
    handleViewData(){
        this.state.application.updateDataView({MIME : this.state.manifest.data.get_mime().data, data : this.state.manifest.rawData});
        this.state.updateApp();
        this.state.dataTogglePopup();
        
        
    }
    handleManifestView()
    {
        let manifest = this.props.manifest;
        this.state.updateApp();
        this.state.application.updateDataView({MIME : "manifest", data : manifest.data});
        this.state.dataTogglePopup();
 
    }
        

    handleChangeManifestFocus()
    {
        if (this.state.rootManifest)
            this.state.application.PopManifestFocusList()
        else
            this.state.application.PushManifestFocusList(this.state.manifest)
    }

    updateManifest()
    {
        this.setState({
            manifest: this.state.application.getCurrentManifest(),
            init_manifest: this.state.application.getCurrentManifest(),
        });
        this.state.updateApp();
    }

    handleFetchManifest(event)
    {
        let btn = event.target
        let btn_caption = event.target.innerHTML

        event.target.innerHTML = "fetching...";

        this.state.network.search_manifest_by_doi(event.target.value).then( fetchRes => {
            if ("ok" === fetchRes.status)
            {
                this.setState({
                    manifest: fetchRes
                })
                
                this.state.updateApp()
            }
            else
                btn.innerHTML = btn_caption
        })
    }

    handleRemoveManifest(event)
    {
        if (this.state.cache.delete_manifest_by_doi(event.target.value))
        {
            this.setState({
                manifest: this.state.init_manifest
            })

            this.state.updateApp()
        }
    }

    handleFetchData(event)
    {
        let btn = event.target
        let btn_caption = event.target.innerHTML

        event.target.innerHTML = "fetching...";

        this.state.network.search_data_by_doi(event.target.value).then( fetchRes => {
            
            if ("ok" === fetchRes.status)
            {
                let updatedManifest = this.state.manifest
                updatedManifest.rawData = fetchRes.data

                this.setState({
                    manifest: updatedManifest
                })
            }
            else
                btn.innerHTML = btn_caption 

            this.state.updateApp()
        })
    }

    handleRemoveData(event)
    {
        if (this.state.cache.delete_data_by_doi(event.target.value))
        {
            let updatedManifest = this.state.manifest
            updatedManifest.rawData = null

            this.setState({
                manifest: updatedManifest
            })

            this.state.updateApp()
        }
    }

    getManifestHeader()
    {
        
        let ManifestHeader = <div>"Has no DOI"</div>

        let manifestDoi = this.state.manifest.data.get_doi()

        if ("ok" === manifestDoi.status)
        {
            let doi = manifestDoi.data[0]

            // this trick needs to update same manifests in other formulas !
            {
                let manifestInCache = this.state.cache.get_manifest_by_doi(doi)
                if ("ok" === manifestInCache.status)
                    this.state.manifest = manifestInCache
                else
                    this.state.manifest = this.state.init_manifest

                let dataInCache = this.state.cache.get_data_by_doi(doi)
                if ("ok" === dataInCache.status)
                    this.state.manifest.rawData = dataInCache.data
                else
                {
                    let raw_value = this.state.manifest.data.get_raw_value()
                    if ("ok" === raw_value.status)
                        this.state.manifest.rawData = raw_value.data
                    else
                        this.state.manifest.rawData = null
                }
            }

            let manifestMime = ("ok" === this.state.manifest.data.get_mime().status) ? "MIME: '" + this.state.manifest.data.get_mime().data + "'" : this.state.manifest.data.get_mime().status

            let manifestSize = ("ok" === this.state.manifest.data.get_size().status) ? "Size: " + this.state.manifest.data.get_size().data + "" : this.state.manifest.data.get_size().status

            if (doi)
            {
                if (doi.length > 10)
                    ManifestHeader = "DOI: " + doi.substr(0,10) + "..." + doi.substr((doi.length - 10), 10) 
                     + manifestMime + ", " + manifestSize
                else
                    ManifestHeader = "DOI: " + doi + "; "  + manifestMime + ", " + manifestSize
            }
            else
                ManifestHeader = "Has no DOI " + manifestMime + ", " + manifestSize

            if ( null != this.state.manifest.rawData )
            {    
                let rawData = new Uint8Array(this.state.manifest.rawData).toString()
                ManifestHeader = ManifestHeader + ", Data: " + rawData.substr(0,10) + "..." + rawData.substr((rawData.length - 10), 10)
            }
            else
                ManifestHeader = ManifestHeader + ", Has no data"

            ManifestHeader = ManifestHeader + ")"
            
        }

        let manifestS = <div className="text-left m-2">

        <p className="m-1">MIME: {(this.state.manifest.data.get_mime().data !== null) ? this.state.manifest.data.get_mime().data : "Has no MIME"}</p>

         <p className="m-1">Size: {(this.state.manifest.data.get_size().data !== null) ? (this.state.manifest.data.get_size().data/1024).toFixed(2) + " kB" : "Has no size"}</p>

        <p className="m-1 text-truncate">DOI: {(this.state.manifest.data.get_doi().data !== null) ? this.state.manifest.data.get_doi().data : "Has no DOI"}</p>

         <p className="m-1"> Raw Value: {(this.state.manifest.rawData !== null) ? this.state.manifest.data.get_raw_value().data : "There is no raw value"}</p>
      </div>;

    return ManifestHeader && manifestS
    }

    getManifestControls()
    {
        let ManifestControls = ""
       
        let manifestDoi = this.state.manifest.data.get_doi()

        let viewButton;
         viewButton=<button className="btn btn-sm btn-success m-1" onClick={this.handleManifestView}>View Manifest</button>
        
        
        let viewDataButton;
         viewDataButton=<button className="btn btn-sm btn-success m-1" onClick={this.handleViewData}>View Data</button>
       
        

        if ("ok" === manifestDoi.status)
        {
            let doi = manifestDoi.data[0]

            let manifestInCache = this.state.cache.get_manifest_by_doi(doi)

            let mC = ""
            if ("ok" === manifestInCache.status)
                mC = <div ><button className="btn btn-sm btn-danger m-1" onClick={this.handleRemoveManifest} value={doi}>Remove Manifest</button></div>
                
            else
                mC = <div><button className="btn btn-sm btn-primary m-1" onClick={this.handleFetchManifest} value={doi}>Fetch Manifest</button>       
                </div>
            
            let pW = <div>{viewButton}
            </div>
               

            let dataInCache = this.state.cache.get_data_by_doi(doi)

            let dC = ""
            if ("ok" === dataInCache.status)
                dC = <div><button className="btn btn-sm btn-danger m-1" onClick={this.handleRemoveData} value={doi}>Remove Data</button></div>
            else
                dC = <div><button className="btn btn-sm btn-primary m-1" onClick={this.handleFetchData} value={doi}>Fetch Data</button></div>

            let dV = ""
            if ((("ok" === manifestInCache.status)||("ok"===this.state.manifest.data.get_mime().status)) && ("ok" === dataInCache.status))
                dV = <div>{viewDataButton}
                </div> 
            else
            {
                if (("ok"===this.state.manifest.data.get_mime().status) && this.state.manifest.rawData)
                    dV = <div><button className="btn btn-sm btn-info m-1" onClick={this.handleViewData}>View Data</button>
                    </div>  
            }

            

            ManifestControls = <div className="btn-group bg-secondary border-0" role="group" aria-label="Manifest controls">
            <div>{mC}</div><div>{dC}</div><div>{dV}</div><div>{pW}</div>
            
            </div>

        }

        return ManifestControls
    }

    getManifestFormulas()
    {
        let ManifestFromulas = ""

        let formulas = this.state.manifest.data.get_formulas()

        if (0 === formulas.data.length)
        {
            if ("ok" !== formulas.status)
                ManifestFromulas = "Error getting formulas: " + formulas.status
            else
                ManifestFromulas = "Has no formulas"
        }
        else
            ManifestFromulas = formulas.data.map(formula => <div className="bg-secondary text-white">

            <Formula application={this.state.application} dataTogglePopup={this.state.dataTogglePopup} updateApp={this.state.updateApp} formula={formula}/></div>)


        return ManifestFromulas 
    }
    

    render()
    {
        if ((null == this.state.manifest) || ("ok" !== this.state.manifest.status))
        {
            let outStr = (null != this.state.manifest) ? this.state.manifest.status : "is not defined"

            return (

                <nav className="Manifest bg-secondary text-white m-2">
                    <div className="alert alert-success alert-dismissible fade show rounded-lg">
                        <div className="col-md-12 font-weight-bold">MANIFEST</div>
                        <div>{outStr}</div>
                    </div>
        </nav>
            )
        }

        let focus_button = <button className="btn btn-md btn-secondary" onClick={this.handleChangeManifestFocus}><span role="img" aria-label="lookup">&#x1F50D;</span></button>

        if (this.state.rootManifest)
        {
            if (false === this.state.application.ManifestFocusListIsEmpty())
                focus_button = <button className="btn btn-md btn-secondary" onClick={this.handleChangeManifestFocus}><span role="img" aria-label="return">&#9166;</span></button>
            else
                focus_button = "";
        }
        
        let show_formulas = "";
        {if (this.props.showFormulas) show_formulas = <div>
            {focus_button}
        <div>{this.getManifestFormulas()}</div></div>
        else show_formulas = null;
        
   }

        return (
            <nav className="Manifest">
                <div className="p-1 border-0 bg-secondary rounded-lg text-white">

                <div className="d-flex justify-content-end m-0">{focus_button}</div>
                    <div className="alert alert-success alert-dismissible fade show rounded-lg"> {this.getManifestHeader()}</div>
                    
                    <div>
                    
                        {this.getManifestControls()}
                        
                    </div>
                   
                    <div>
                        {this.getManifestFormulas()} 
                    </div>
      
                </div>
            </nav>
        );
    }
}

export default Manifest;